import React from 'react';
import { Container, Button, NavLink } from 'reactstrap';

const CTASection: React.FC = () => {
  return (
    <section className="cta-section py-5">
      <Container>
        <h2 className="fw-bold fs-2 text-center">Transform Your SaaS Operations Today</h2>
        <p className="lead mt-3 fs-5 text-center">
          Join 1,000+ businesses and streamline your multi-tenant SaaS platform with ease.
        </p>
        <div className="d-flex justify-content-center gap-4 mt-4">
          <Button color="primary" size="lg">
            <NavLink href="#tenant-request" className="text-white text-decoration-none">
              Start Free Trial
            </NavLink>
          </Button>
          <Button color="light" size="lg">
            Talk to Sales
          </Button>
        </div>
      </Container>
    </section>
  );
};

export default CTASection;
